import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'identifierColumnLabel',
})
export class IdentifierColumnLabelPipe implements PipeTransform {
  transform(identifierName: string, linkedItemDeleted: boolean, hasAccessToHierarchy: boolean): string {
    identifierName = identifierName || '';
    if (linkedItemDeleted === true) {
      identifierName = identifierName.concat(' (Removed)');
    }
    if (hasAccessToHierarchy === false) {
      identifierName = identifierName.concat(' (Restricted)');
    }
    return identifierName;
  }
}
